import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import Utils from '@shared/utils/utils';
import { FormGroup, Validators } from '@angular/forms';
import { Company } from '@shared/enums/company';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-dealer-contact-edit',
  templateUrl: './dealer-contact-edit.component.html',
  styleUrls: ['./dealer-contact-edit.component.scss']
})
export class DealerContactEditComponent extends DialogBase implements OnInit {

  id: any;
  title: any;
  bpNo: any;
  buttonLabel: any;
  hq: boolean;

  contactInfo: any;
  detailForm: FormGroup;
  statuses = [];
  allStores = [];
  error: any;
  showDealerList: boolean = false;
  dealerList = [];
  newContactInfo: any;

  roles: any = [];
  company;
  companies = Company;
  role;

  get form() {
    return this.detailForm.controls;
  }

  ngOnInit(): void {
    this.company = this.authService.getCurrentCompany();
    this.roles = this.company === this.companies.Seca ? [{
      code: 'DEALER_SUPERVISOR',
      name: 'Manager'
    }, {
      code: 'DEALER_STAFF',
      name: 'Staff'
    }] : [{
      code: 'DEALER_SUPERVISOR',
      name: 'Manager'
    }];

    this.setFormControls();
    if (!this.showDealerList) {
      this.setSelectOptions();
    }

    if (this.contactInfo) {
      this.setEdit(this.contactInfo);
      this.getUser(this.contactInfo.email);
    }

    if (this.showDealerList) {
      this.setEdit(this.newContactInfo);
      this.apiService.dealer.getAllDealers(this.company).subscribe(res => {
        this.dealerList = res;
      });
      const list = ['firstName', 'lastName', 'tel', 'ext']
      list.map(item => {
        this.detailForm.controls[item].disable();
      })
    }

    this.detailForm.controls['employeeNo'].disable();
  }

  getUser(username) {
    this.apiService.user.getUser(username)
      .subscribe(res => {
        this.role = res.roles.find(r => r.company === this.company)?.groups.join(', ');
        this.detailForm.controls['role'].setValue(this.role);
        this.detailForm.controls['employeeNo'].setValue(res.employeeNo);
      }, err => Utils.showError(err));
  }

  setFormControls() {
    if ([this.companies.SeaIm].includes(this.company)) {
      this.detailForm = this.fb.group({
        _id: null,
        bpNo: null,
        firstName: [null, Validators.required],
        lastName: [null, Validators.required],
        tel: [null, Validators.compose([Validators.required, Validators.pattern(/\d{3}\d{3}\d{4}/g)])],
        email: [null, Validators.compose([Validators.required, Validators.email])],
        employeeNo: null,
        role: null,
        ext: null,
        stores: null,
        optOut: null,
      });
    } else {
      this.detailForm = this.fb.group({
        _id: null,
        bpNo: null,
        firstName: [null, Validators.required],
        lastName: [null, Validators.required],
        tel: [null, Validators.compose([Validators.pattern(/\d{3}\d{3}\d{4}/g)])],
        email: [null, Validators.compose([Validators.required, Validators.email])],
        employeeNo: null,
        role: null,
        ext: null,
        stores: null,
        optOut: null,
      });
    }
  }

  setSelectOptions() {
    this.apiService.dealer.getAllStores(this.bpNo)
      .subscribe(res => {
        this.allStores = res;
      });
  }


  async submitForm($event) {
    $event.stopPropagation();
    $event.preventDefault();

    if (this.detailForm.invalid) {
      this.detailForm.markAllAsTouched();
      return;
    }

    let contactData = this.detailForm.getRawValue();
    let bpNo = '';
    if ([Company.Sea].includes(this.company)) {
      if (contactData?.stores && contactData?.stores.length > 0) {
        try {
          this.spinnerService.start();
          bpNo = await this.bpService.saveContactBp(contactData, this.allStores, this.company);
        } catch (error) {
          await this.spinnerService.stop()
          await Swal.fire({
            title: error.error.message,
            text: error.error.payload.errorFields[0].message,
            icon: 'error',
          });
          return;
        }
      } else {
        bpNo = null;
      }
    }

    if (this.detailForm.invalid) {
      this.detailForm.markAllAsTouched();
      return;
    }
    let dealerContact
    if ([Company.Sea].includes(this.company)) {
      dealerContact = {
        firstName: contactData.firstName,
        lastName: contactData.lastName,
        email: contactData.email,
        tel: contactData.tel,
        ext: contactData.ext,
        role: contactData.role,
        employeeNo: bpNo,
        stores: contactData.stores,
        optOut: contactData?.optOut,
      };
    } else {
      dealerContact = {
        firstName: contactData.firstName,
        lastName: contactData.lastName,
        email: contactData.email,
        tel: contactData.tel,
        ext: contactData.ext,
        role: contactData.role,
        employeeNo: this.bpNo,
        stores: contactData.stores,
        optOut: contactData?.optOut,
      };
    }

    if (this.id) {
      this.apiService.dealer.updateContact(this.bpNo, this.id, dealerContact)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          Swal.fire({
            title: 'Dealer Contact Updated',
            text: 'Dealer Contact updated successfully.',
            icon: 'success',
            allowOutsideClick: false,
          }).then((result) => {
            this.onClose.next(res);
            this.bsModalRef.hide();
          });
        }, err => Utils.showError(err));
    } else {
      this.apiService.dealer.createContact(this.bpNo, dealerContact)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          Swal.fire({
            title: 'Dealer Contact Created',
            text: 'Dealer Contact created successfully. Registration email sent to the new dealer contact',
            icon: 'success',
            allowOutsideClick: false,
          }).then((result) => {
            this.onClose.next(res);
            this.bsModalRef.hide();
          });
        }, err => Utils.showError(err));
    }
  }

  checkEmail($event) {
    const bpNo = this.bpNo;
    const emailValue = $event.target.value;
    if (!emailValue) {
      return;
    }

    this.apiService.user.checkDuplicateEmail(emailValue)
      .subscribe(res => {
      }, err => {
        Utils.showError(err);
        this.form['email'].setValue(null);
      });
  }

  setDealerInfo($event) {
    this.allStores = [$event];
    this.bpNo = $event.bpNo;
  }

  private setEdit(detailInfo) {
    const form = this.detailForm.controls;
    Object.keys(form).forEach(key => {
      form[key].setValue(detailInfo[key]);
      if (key === 'email' || key === 'employeeNo') {
        form[key].disable();
      }
    });
  }
}
